interface Args {
  /** Roster ids the team actually has, from `GET /teams/:id/rosters`. */
  availableIds: string[]
  /** The roster resolved from the division the user opened. */
  wantedId: string
  /** Whatever the legacy roster picker currently has selected. */
  currentId: string
}

/**
 * Whether the roster selection must be corrected to the division's roster.
 *
 * The legacy picker chooses an initial roster from URL state and a first-render
 * snapshot, either of which can land on the wrong competition's roster for a
 * team that plays in several. This decides when to override it.
 *
 * Waits for the roster list, because the fetch that loads players and team
 * officials is gated on that list being present — pinning earlier is dropped.
 * Never pins an id the team does not have, so a stale value cannot blank the
 * panel.
 */
export const shouldPinRoster = ({
  availableIds,
  wantedId,
  currentId,
}: Args): boolean => {
  if (availableIds.length === 0 || !wantedId || currentId === wantedId) {
    return false
  }
  return availableIds.includes(wantedId)
}
